export const CONTACTS = {
  URL: '/contacts',
  TITLE: 'Контакты'
}



// WEBPACK FOOTER //
// ./src/features/Contacts/links.js